import type React from 'react'
import { createContext } from 'react'

interface MultistepFiltersContextType {
  activeFilter: string | null;
  contentElement: HTMLElement | null;
  contentId: string;
  editing: boolean;
  filterRef: React.MutableRefObject<HTMLElement | null>;
  setActiveFilter: (question: string | null) => void;
  setEditing: (editing: boolean) => void;
}

export const MultistepFiltersContext = createContext<MultistepFiltersContextType>({
  activeFilter: null,
  contentElement: null,
  contentId: '',
  editing: false,
  filterRef: { current: null },
  setActiveFilter: () => {},
  setEditing: () => {},
})
